import { takeEvery, put, select } from 'redux-saga/effects';

import { USER_PROFILE_FETCH_SUCCESS } from '../../actions/actionTypes/userProfile';
import { types as callTypes } from '../../actions/backendCall';
import { getUserASRConfig, updateUserASRConfig } from '../../actions/backendAsr';

import { getIsTrainerActive } from '../../selectors/call';

const putThunk = (action: unknown) => put(action as never);

export function* doGetAsrConfig(): Generator<unknown, void, unknown> {
    const isTrainerActive = yield select(getIsTrainerActive);
    if (!isTrainerActive) return;
    yield putThunk(getUserASRConfig());
}

export function* getAsrConfig(): Generator<unknown, void, unknown> {
    yield takeEvery(USER_PROFILE_FETCH_SUCCESS, doGetAsrConfig);
}

export function* doUpdateAsrConfig(): Generator<unknown, void, unknown> {
    yield putThunk(updateUserASRConfig());
}

export function* updateAsrConfig(): Generator<unknown, void, unknown> {
    yield takeEvery([callTypes.CALL_ENDED], doUpdateAsrConfig);
}

export default [getAsrConfig(), updateAsrConfig()];
